import Service, { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import Sentry from '@banking/ui/services/sentry';
import { addProtoContext } from '@banking/api/utils/sentry';
import { isForbidden, isUnauthorized } from '@banking/api/utils/auth-errors';
import { replace } from '@square/dashboard-utilities/utils/window';
import type { ConnectError } from '@square/ember-rpc-client/utils';
import { Scope } from '@sentry/ember';
import type { EventHint } from '@sentry/ember';

export default class ErrorHandler extends Service {
  @service router!: RouterService;
  @service sentry!: Sentry;

  handleRpcError(error: ConnectError, options: { errorRoute?: string } = {}) {
    const scope = new Scope();
    addProtoContext(error)(scope);
    const hint: EventHint = {
      data: {
        context: scope,
      },
    };
    this.sentry.captureException(error, hint);

    if (isUnauthorized(error)) {
      replace(
        `/login?return_to=${window.encodeURIComponent(
          window.location.pathname
        )}`
      );
    } else if (isForbidden(error)) {
      this.router.transitionTo('forbidden');
    } else {
      if (options.errorRoute && /\.error$/.test(options.errorRoute)) {
        // Since this is a substate transitioning to it requires an error model (second arg)
        // This also means we are transitioning without updating the URL
        this.router.transitionTo(options.errorRoute, error);
      } else {
        // Normal routes will throw if you try to transition with too many args
        this.router.transitionTo(options.errorRoute || 'signup.errored');
      }
    }
  }
}
